import { useBrandQuery } from './brands/hooks';

export function useCampaignParents(brandId: string) {
  const brand = useBrandQuery(brandId);
  return { brand };
}
